import { useEffect, useMemo, useState } from 'react';

import useTranslation from '@/utils/hooks/translation/useTranslation';
// Utils
import useAcl from '@/utils/hooks/user/useAcl';

import PropTypes from 'prop-types';

// Lib
import { aclFeatures } from '@/lib/acl/aclFeatures';

// Components
import Label from '@/components/base/Label';
import Radio from '@/components/base/Radio';
import FilterSectionTitle from '@/components/pages/myprofile/filters/FilterSectionTitle';

const FilterPromotionType = ({ resetFilters, stopResetFilters, setRequestParams }) => {
    const { hasAcl } = useAcl();
    const isLocked = !hasAcl(aclFeatures.analytic.promoted_post.read);
    const { t } = useTranslation('myprofile');
    const promotionTypesList = useMemo(() => {
        return [
            { label: t('promotion_type.filter_all'), value: 'all' },
            { label: t('promotion_type.filter_promoted'), value: 'promoted' },
            { label: t('promotion_type.filter_not_promoted'), value: 'non_promoted' }
        ];
    }, [t]);
    const [activeType, setActiveType] = useState([promotionTypesList[0].value]);

    useEffect(() => {
        setRequestParams((prevState) => {
            if (
                activeType.length === 1 &&
                activeType?.filter((item) => item === 'all').length === 0
            ) {
                return {
                    ...prevState,
                    filter_promotion_type: activeType[0]
                };
            }

            if (prevState) {
                delete prevState.filter_promotion_type;
            }
            return { ...prevState };
        });
    }, [activeType, setRequestParams]);

    useEffect(() => {
        if (resetFilters) {
            setActiveType([promotionTypesList[0].value]);
            stopResetFilters();
        }
    }, [resetFilters]);

    return (
        <div>
            <FilterSectionTitle icon="paid-data" isLocked={isLocked}>
                {t('promotion_type.label')}
            </FilterSectionTitle>
            <ul className="space-y-2.5">
                {promotionTypesList.map((typePost, index) => {
                    const isDisabled =
                        isLocked ||
                        activeType.some(
                            (item) => item === typePost.value && typePost.value === 'all'
                        );
                    return (
                        <li key={index}>
                            <Label
                                fontType={isDisabled ? 'checkboxListDisabled' : 'checkboxList'}
                                className={`relative pl-7 ${!isDisabled && 'cursor-pointer'}`}>
                                <Radio
                                    disabled={isDisabled}
                                    id={`type-promotion-${typePost.value}`}
                                    name="type-promotion"
                                    checked={activeType?.some((item) => item === typePost.value)}
                                    className="absolute -top-px left-0"
                                    onChange={(e) => setActiveType([e.target.value])}
                                    value={typePost?.value}
                                />
                                <span className="align-middle">{typePost.label}</span>
                            </Label>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

FilterPromotionType.propTypes = {
    resetFilters: PropTypes.bool,
    stopResetFilters: PropTypes.func,
    setRequestParams: PropTypes.func.isRequired
};

export default FilterPromotionType;
